var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"anx-table-row"},[_vm._t("default",function(){return _vm._l((_vm.item),function(content,name){return _c('td',{key:name},[_vm._v(_vm._s(content))])})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }